import React from 'react';
import { Banknote } from 'lucide-react';
import { formatCurrency, formatPercent, formatDuration } from '../../../../utils/formatters';
import { Card, CardHeader, CardTitle, CardContent } from '../../../../components/ui/Card';
import DefinitionItem from './DefinitionItem';

export default function PrivateFinancingOverview({ transaction }) {
  return (
    <Card className="shadow-hp-sm">
      <CardHeader className="flex flex-row items-center gap-3 border-b border-[var(--hp-color-border-muted)] px-5 py-4">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-muted text-primary">
          <Banknote className="h-4.5 w-4.5" />
        </div>
        <div>
          <CardTitle className="text-base font-semibold text-primary">Financement Privé (Dette)</CardTitle>
          <p className="mt-0.5 text-sm text-subtle">Structure du prêt et modalités d'amortissement.</p>
        </div>
      </CardHeader>

      <CardContent className="p-5">
        <dl className="grid grid-cols-1 gap-x-6 gap-y-5 sm:grid-cols-2 lg:grid-cols-3">
          <DefinitionItem
            label="Principal (Emprunt)"
            value={formatCurrency(transaction.targetAmount, transaction.currency)}
            emphasis
          />

          <DefinitionItem
            label="Taux d'intérêt annuel"
            value={formatPercent(transaction.yieldRate)}
          />

          <DefinitionItem
            label="Maturité"
            value={formatDuration(transaction.durationMonths)}
          />

          <DefinitionItem
            label="Type d'amortissement"
            value={null}
          />

          <DefinitionItem
            label="Périodicité"
            value={null}
          />

          <DefinitionItem
            label="Garanties"
            value={null}
          />
        </dl>
      </CardContent>
    </Card>
  );
}
